import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { loadingAnimation } from 'app/utils/animations.util';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss'],
	animations: [loadingAnimation],
})
export class LogoutComponent implements OnInit {
	// Translated strings.
	strLoggingOut: string;

	// Constructor method.
	constructor(
		private authenticationService: AuthenticationService,
		private translate: TranslateService
	) {
		// Get translated texts.
		this.translate.get(['LOGIN.STATUS.LOGGINGOUT']).subscribe((res) => {
			// Strings.
			this.strLoggingOut = res['LOGIN.STATUS.LOGGINGOUT'];
			// Run logout.
			this.authenticationService.logout();
		});
	}

	// On init.
	ngOnInit() {}
}
